<template>
  <a-popover
    trigger="click"
    overlay-class-name="key-result-alignment"
  >
    <template #content>
      <div>
        <a-input
          :placeholder="$t('shared.searchInputPlaceHolder')"
          @input="e => search(e.target.value)"
        >
          <template #prefix>
            <UserOutlined type="user" />
          </template>
        </a-input>
        <div class="alignment-contact-list">
          <div
            v-if="isLoading"
            :style="{ textAlign: 'center' }"
          >
            <a-spin size="small" />
          </div>
          <template v-else>
            <div
              v-if="isFrequentContactsVisible"
              class="frequent-contacts-title"
            >
              {{ $t('shared.frequentContacts') }}
            </div>
            <a-space direction="vertical">
              <a-checkbox
                v-for="user in users"
                :key="user.uid"
                :checked="mentionedUserIds.includes(user.uid)"
                :disabled="user.uid === myUserId"
                @change="onCheckUser(user.uid, $event.target.checked)"
              >
                <AlignUser :user="user" />
              </a-checkbox>
            </a-space>
          </template>
        </div>
      </div>
    </template>
    <a-button :size="size">
      <template #icon>
        @
      </template>
    </a-button>
  </a-popover>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { UserOutlined } from '@ant-design/icons-vue'

import useSearchUser from '@/composables/use-search-user'
import AlignUser from '@/components/AlignDialog/AlignUser'

export default {
  name: 'MentionDialog',
  components: {
    UserOutlined,
    AlignUser
  },
  props: {
    content: {
      type: String,
      required: true
    },
    mentionedUserIds: {
      type: Array,
      required: true
    },
    size: {
      type: String,
      required: true
    }
  },
  emits: [
    'update:content',
    'update:mentioned-user-ids'
  ],
  setup (props, { emit }) {
    const { state } = useStore()
    const myUserId = computed(() => state.user.uid)
    const { users, search, isLoading, isFrequentContactsVisible } = useSearchUser()

    function update (content, mentionedUserId) {
      emit('update:content', content)
      emit('update:mentioned-user-ids', mentionedUserId)
    }

    function mentionUser (user) {
      const content = props.content + ` @${user.name} `
      const mentionedUserIds = [
        ...props.mentionedUserIds,
        user.uid
      ]

      update(content, mentionedUserIds)
    }

    function removeMentionedUser (user) {
      const content = props.content
        .replaceAll(`@${user.nickname}`, '')
        .replaceAll(`@${user.name}`, '').trim()
      const mentionedUserIds = props.mentionedUserIds.filter(id => id !== user.uid)

      update(content, mentionedUserIds)
    }

    function onCheckUser (id, checked) {
      const user = users.value.find(user => user.uid === id)
      if (checked) {
        mentionUser(user)
      } else {
        removeMentionedUser(user)
      }
    }

    return {
      users,
      search,
      isLoading,
      isFrequentContactsVisible,
      onCheckUser,
      myUserId
    }
  }
}
</script>

<style lang="less" scoped>
:deep(.ant-checkbox-wrapper) {
  display: flex;
  align-items: center;
}
</style>
